module.exports = __webpack_public_path__ + "static/img/30009 (1).8b17d49.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30009 (1).webp
// module id = knVt
// module chunks = 14